import { useEffect, useState } from 'react';
import { Alert } from '@vkontakte/vkui';
import { PERMISSION_DENIED_EVENT } from '../api/events';

export default function PermissionDeniedAlert() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(PERMISSION_DENIED_EVENT, handler);
    return () => window.removeEventListener(PERMISSION_DENIED_EVENT, handler);
  }, []);

  if (!open) return null;

  return (
    <Alert
      actionsLayout="vertical"
      actions={[{ title: 'Понятно', mode: 'cancel', action: () => setOpen(false) }]}
      title="Нет разрешения"
      description="У вас нет на это разрешения. Попросите дать его у создателя свадьбы."
      onClose={() => setOpen(false)}
      onClosed={() => setOpen(false)}
    />
  );
}
